<template>
  <div class="plan">
    <div class="banner">
       <el-image :src="plan[index].url" class="banner-img" ></el-image>
    </div>
    <div class="tag">
      <div class="title">
        <div class="slogan">{{plan[index].slogan}}</div>
        <div class="sloganen">{{plan[index].sloganen}}</div>
      </div>
    </div>


    <div id="about-meau">
        <el-tabs v-model="activeName" @tab-click="planMenuSelect">
        <el-tab-pane v-for="item in menus" :key="item.id" :name="item.type" :label=" item.name">{{ item.name }}</el-tab-pane>
        </el-tabs>
    </div>
    <div class="about-meau-content" >
      <div class="ql-editor" v-html="content.content"></div>
    </div>
  </div>
</template>
<script>
import { getRequest } from "../../util/api";
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
export default {
  data() {
    return {
    menus: [],
    content: "",
    activeName: '',
    index:0,
    tagtype:'',
    pid:0,
    plan:[
      { url:require('../../assets/home/plan1.png'),slogan:'低压拓扑传感器',sloganen:'LOW-VOLTAGE TOPOLOGY SENSOR'},
      { url:require('../../assets/home/plan2.png'),slogan:'充电桩扩容',sloganen:'CHARGING PILE EXPANSION'},
      { url:require('../../assets/home/plan3.png'),slogan:'安全用电测控终端',sloganen:'SAFE ELECTRICAL MEASUREMENT AND CONTROL TERMINAL'},
      { url:require('../../assets/home/plan4.png'),slogan:'智慧水电',sloganen:'SMART HYDROPOWER'},
      { url:require('../../assets/home/plan5.png'),slogan:'IT产品及服务',sloganen:'IT PRODUCTS AND SERVICES'}
    ]
    };
  },
  mounted() {
    this.tagtype=this.$route.query.id;
    if('low_voltage'==this.tagtype){
      this.index=0;
      this.pid=64;
    }else if('expansion'==this.tagtype){
      this.index=1;
      this.pid=65;
    }else if('terminal'==this.tagtype){
      this.index=2;
      this.pid=66;
    }else if('smart_hyd'==this.tagtype){
      this.index=3;
      this.pid=67;
    }else {
      this.index=4;
      this.pid=68;
    }

    this.getMenuChildren(this.pid);
  },
    watch: {
    '$route.query.id':function(newVal){
        if('low_voltage'==newVal){
          this.index=0;
          this.pid=64;
        }else if('expansion'==newVal){
          this.index=1;
          this.pid=65;
        }else if('terminal'==newVal){
          this.index=2;
          this.pid=66;
        }else if('smart_hyd'==newVal){
          this.index=3;
          this.pid=67;
        }else {
          this.index=4;
          this.pid=68;
        }

      this.getMenuChildren(this.pid);
    }
  },
  methods: {
    planMenuSelect(tab, event) {
      let that = this;
      that.getMenuContent(tab.name);
    },
    getMenuChildren(pid) {
      let that = this;
      let params = {
        pid: pid
      };
      getRequest("/menus/type", params).then(function(res) {
        if (res.data.meta.code == 1) {
          console.log("进来了hah");
          that.menus = res.data.data;
          that.activeName=res.data.data[0].type;
          that.getMenuContent(that.activeName);
        }
      });
    },
      getMenuContent(key){
       let that = this
      let params = {
        type: key,
      }
      that.content = ''
      getRequest('/menus/info',params).then(function(res) {
        if (res.data.meta.code == 1) {
          console.log('/menus/info')
           that.content = res.data.data
        }
      })
    }
  }
};
</script>
<style>
.plan {
  width: 99%;
}
/* .about-meau-content img{
  width: 100%;
  height: 100%;
} */
</style>
<style src="../../css/banner.css"></style>


// WEBPACK FOOTER //
// src/components/content/Plan.vue